import { ResourcePointMergeFeaturePage } from "..";

/** 资源合并独立路由入口。 */
export function ResourcePointMergePage() {
  return <ResourcePointMergeFeaturePage />;
}
